/**
 * Map store name to the canonical design-token brand used for CSS-scoping
 * purposes (the `data-theme` attribute, `@chemist4u/newt-tokens` selectors,
 * and the `BrandSlug` passed to `@chemist4u/newt-components`).
 *
 * c4u ships no token/theme CSS of its own yet, so it borrows mypharmacy's —
 * mirrors CANONICAL_BRAND_MAP in build-tokens.mjs / build-fonts.mjs /
 * build-newt-tokens.mjs. Deliberately separate from `getThemeName`, which
 * resolves c4u to 'base' for sprite/navigation-config selection instead.
 */
export function getCanonicalThemeBrand(
  store: string,
): 'mypharmacy' | 'mybmi' | 'myweightloss' {
  switch (store) {
    case 'myp':
    case 'mypharmacy':
    case 'c4u':
      return 'mypharmacy';
    case 'mybmi':
    case 'bmi':
      return 'mybmi';
    case 'mwl':
    case 'myweightloss':
      return 'myweightloss';
    default:
      return 'mypharmacy';
  }
}
